import React from "react";
import Layout from "../components/layout";
import HomeHeader from "../components/home-header/home-header.component";
import ServiceStrip from "../components/service-strip/service-strip.component";
import RelatedLinks from "../components/related-links/related-links.component";
import AwardPanel from "../components/award-panel/award-panel.component";
import FaqNewsPanel from "../components/faq-news-panel/faq-news-panel.component";
import BrokerSupport from "../components/broker-support/broker-support.component";
import ApplicationCentreLink from "../components/application-centre-link/application-centre-link.component";
import InfoCard from "../components/info-card/info-card.component";
import BrokerBanner from "../components/broker-banner/broker-banner.component";
import "../styles/app.scss";
// import LinkToGreenPage from "../components/green-page/link-to-greenpage.component";
import { triggerTealiumEvent } from "../utils/tealiumUtils";
import { useLocation } from "@reach/router";

const infoCards = [
  {
    title: "High Value Mortgage Service",
    description: "Professional and personal service dedicated to loans over 1 million.",
    linkText: "Find out more",
    linkHref: "/high-value-mortgage-services",
    colClass: "col-xs-12 col-xl-3",
    tealiumEventName: "High Value Mortgage Service"
  },
  {
    title: "Useful documents",
    description: "Forms and useful reference guide to help support your applications.",
    linkText: "Take me there",
    linkHref: "/resources",
    colClass: "col-xs-12 col-xl-3",
    tealiumEventName: "Useful documents"
  }
];

export default function Home() {
  const location = useLocation();
  if (typeof window !== "undefined" && window.utag) {
    triggerTealiumEvent("view", location.href, "", "", "", "homepage", "Home", "10451v1");
  }

  return (
    <Layout>
      <HomeHeader />
      <section className="row section home-section">
        <ServiceStrip />
        <ApplicationCentreLink />
      </section>
      <section className="row section home-section home-section-last">
        <InfoCard
          title={infoCards[0].title}
          description={infoCards[0].description}
          linkText={infoCards[0].linkText}
          linkHref={infoCards[0].linkHref}
          colClass={infoCards[0].colClass}
          backgroundColor="rgba(62, 80, 93, 1)"
          tealiumEventName={infoCards[0].tealiumEventName}
        />
        <BrokerBanner />
        <InfoCard
          title={infoCards[1].title}
          description={infoCards[1].description}
          linkText={infoCards[1].linkText}
          linkHref={infoCards[1].linkHref}
          colClass={infoCards[1].colClass}
          backgroundColor="rgba(0, 132, 127, 1)"
          tealiumEventName={infoCards[1].tealiumEventName}
        />
      </section>
      {/* <RelatedLinks /> */}
      {/*<LinkToGreenPage />*/}
      {/* <AwardPanel /> */}
      <FaqNewsPanel />
      <BrokerSupport />
    </Layout>
  );
}
